// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2yE0B","footer":"ChangeClinic_footer__sch8N"};